function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.0560304527 0.0691068966 4.48423457 0.0691068966 4.48423457 5.14901494 0.0560304527 5.14901494"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0.0691068966 4.42816502 0.0691068966 4.42816502 5.14901494 0 5.14901494"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "paapaya_main",
  transform: "translate(-337.000000, -1162.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-15",
  transform: "translate(337.000000, 1162.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.47461193,6.10894828 C10.6995255,6.10894828 11.6962045,4.73879885 11.6962045,3.05461494 C11.6962045,1.37027011 10.6995255,4.02298851e-05 9.47461193,4.02298851e-05 C8.24969835,4.02298851e-05 7.25309753,1.37027011 7.25309753,3.05461494 C7.25309753,4.73879885 8.24969835,6.10894828 9.47461193,6.10894828",
  id: "Fill-1",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.47461193,7.12196092 C6.30638148,7.12196092 4.86699465,9.02427126 4.21747613,10.6201103 C3.92137325,11.3472253 3.96914691,12.190846 4.34539383,12.8764437 C4.73133621,13.5799034 5.39015926,13.9999839 6.10778066,13.9999839 L12.8415996,13.9999839 C13.5589082,13.9999839 14.2178095,13.5799034 14.6035955,12.8767655 C14.9799206,12.190846 15.0279288,11.3472253 14.7319823,10.6201103 C14.082151,9.02427126 12.6429988,7.12196092 9.47461193,7.12196092",
  id: "Fill-3",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9242654,7.12546092 C15.8289156,7.12546092 16.5650679,6.11343793 16.5650679,4.86952989 C16.5650679,3.62554138 15.8289156,2.61351839 14.9242654,2.61351839 C14.0196152,2.61351839 13.283463,3.62554138 13.283463,4.86952989 C13.283463,6.11343793 14.0196152,7.12546092 14.9242654,7.12546092",
  id: "Fill-5",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(14.465021, 7.804598)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.34221152,2.65267011 C3.86220741,1.47401494 2.79938025,0.0691068966 0.459252675,0.0691068966 C0.320153909,0.0691068966 0.186293827,0.0746586207 0.0560304527,0.0843137931 C0.621104527,0.698785057 1.08648724,1.44344023 1.43927737,2.30958966 C1.80754897,3.21452069 1.81724444,4.23716437 1.49275885,5.14901494 L2.94598519,5.14901494 C3.47587407,5.14901494 3.96252428,4.83876207 4.2473679,4.31939425 C4.52540905,3.81281954 4.56082881,3.18973908 4.34221152,2.65267011",
  id: "Fill-7",
  fill: "#EEEEEE",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.02495062,7.12546092 C3.12030041,7.12546092 2.38422634,6.11343793 2.38422634,4.86952989 C2.38422634,3.62554138 3.12030041,2.61351839 4.02495062,2.61351839 C4.92967901,2.61351839 5.66575309,3.62554138 5.66575309,4.86952989 C5.66575309,6.11343793 4.92967901,7.12546092 4.02495062,7.12546092",
  id: "Fill-10",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(0.000000, 7.804598)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.141983951,2.65267011 C0.621988066,1.47401494 1.68481523,0.0691068966 4.02502099,0.0691068966 C4.16404156,0.0691068966 4.29797984,0.0746586207 4.42816502,0.0843137931 C3.86309095,0.698785057 3.39770823,1.44344023 3.04491811,2.30958966 C2.6766465,3.21452069 2.66695103,4.23716437 2.99143663,5.14901494 L1.53821029,5.14901494 C1.00839959,5.14901494 0.521671193,4.83876207 0.236827572,4.31939425 C-0.0411353909,3.81281954 -0.0766333333,3.18973908 0.141983951,2.65267011",
  id: "Fill-12",
  fill: "#EEEEEE",
  mask: "url(#mask-4)"
}))))));

function SvgIcoGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGroup);
export default __webpack_public_path__ + "static/media/ico_group.1a4ba42b.svg";
export { ForwardRef as ReactComponent };